import { useContext } from 'react';
import RoomProvider from 'components/Provider/RoomProvider';
import JoinGame from 'components/JoinRoom/JoinRoom';
import PlayersArondTable from 'components/PlayersArondTable/PlayersArondTable';
import PopupMessage, { popupMessageRef } from 'components/PopupMessage/PopupMessage';
import { useLocation } from 'react-router';
import Tchat from 'components/Tchat';
import Tips from 'components/Tips/Tips';

function Game(props) {
    const { room } = useContext(RoomProvider);
    const location = useLocation();
    const roomName = location.pathname.split('/')[2];
    
    if(room?.joined){
        return (
            <div>
                <PlayersArondTable />
                <Tchat />
                <Tips />
                <PopupMessage ref={popupMessageRef} duration={20000} />
            </div>
        );
    }
    else {
        return (
            <JoinGame roomName={roomName} />
        );
    }
}

export default Game;